/** Fixed list of available licensing periods in months (v1). */
export const AVAILABLE_PERIODS = [3, 6, 9, 12, 24] as const;

/** Default requested licensing period in months. */
export const DEFAULT_PERIOD_MONTHS = 12;

/** localStorage key for the global period selector. */
export const PERIOD_STORE_KEY = 'bv-period';

const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  GBP: '£',
  EUR: '€',
};

/** Return a currency symbol for an ISO 4217 code (fallback: the code itself). */
export function currencySymbol(code: string | undefined): string {
  if (!code) return '';
  return CURRENCY_SYMBOLS[code] ?? code;
}
